import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { InputWrapper, InputError } from 'src/components';
import { TextInputExtended } from './TextInputExtended';
import { useOnlyLettersControl } from './use-only-letters-control';
import { useDispatch, useSelector } from 'react-redux';
import { store } from 'src/feature-app';
import { OneFormState } from 'src/types';

interface ApellidoProps {
  name?: 'surname' | 'secondSurname';
  label?: string;
  required?: boolean;
  paddingTop?: string;
  paddingBottom?: string;
}

export function Apellido(props: ApellidoProps) {
  const { register, errors } = useFormContext();
  const { name, label, required } = props;
  const [inputValue, setInputValue] = useState('');
  const [pristine, setPristine] = useState(true);
  const { error, regExp } = useOnlyLettersControl(pristine, inputValue);
  const dispatch = useDispatch();
  const { formInfo } = useSelector((state: OneFormState) => state);

  const handleChange = (e: any) => {
    if (!error) {
      dispatch({ type: 'UPDATE_FIELDS', payload: { [name]: e.target.value } });
    }
    setInputValue(e.target.value);
    setPristine(false);
  };

  return (
    <InputWrapper className="apellido-input-wrapper" notALayer={formInfo.notALayer}  paddingTop={props.paddingTop} paddingBottom={props.paddingBottom}>
      <TextInputExtended
        name={name ? name : 'surname'}
        label={label ? label : 'Apellido'}
        isFloating
        innerRef={register({
			required: {
				value: required ? required : false,
				message: 'Requerido',
			},
			pattern: {
				value: regExp,
				message: 'Solo se aceptan letras',
			},
		})}
        type="text"
        onChange={(e) => handleChange(e)}
        required={required ? required : false}
      />
      {error && <InputError className="input-error">Solo se aceptan letras</InputError>}
    </InputWrapper>
  );
}
